import { useMatch } from "react-router-dom";
import { AppRoutes } from "@router/router-helper";

/** Identifier for the route match */
type RouteIdentifier =
  | "workspace"
  | "project"
  | "member"
  | "workspace-add-plan"
  | "workspace-add-feature"
  | "workspace-add-device-plan"
  | "project-add-plan"
  | "project-add-feature"
  | "add-project"
  | "about-products"
  | "unknown";

/**
 * A hook that matches the current route (pathname) with the provided paths
 * and returns the identifier of the matched route.
 */
export function useAppRouteMatch(): RouteIdentifier {
  const matchCompanyAddPlanRoute = useMatch(AppRoutes.CompanyAddPlanRoute);
  const matchCompanyAddDevicePlanRoute = useMatch(
    AppRoutes.CompanyAddDevicePlanRoute
  );
  const matchCompanyAddFeatureRoute = useMatch(
    AppRoutes.CompanyAddFeatureRoute
  );
  const matchProjectAddPlanRoute = useMatch(AppRoutes.ProjectAddPlanRoute);
  const matchProjectAddFeatureRoute = useMatch(
    AppRoutes.ProjectAddFeatureRoute
  );
  const matchAboutProductsRoute = useMatch(AppRoutes.AboutProductsRoute);
  const matchCompanyRoute = useMatch(AppRoutes.CompanyRoute);
  const matchProjectRoute = useMatch(AppRoutes.ProjectRoute);
  const matchMemberRoute = useMatch(AppRoutes.MemberRoute);
  const matchAddProjectRoute = useMatch(AppRoutes.CompanyAddProjectRoute);

  if (matchCompanyAddPlanRoute) {
    return "workspace-add-plan";
  } else if (matchCompanyAddFeatureRoute) {
    return "workspace-add-feature";
  } else if (matchCompanyAddDevicePlanRoute) {
    return "workspace-add-device-plan";
  } else if (matchProjectAddPlanRoute) {
    return "project-add-plan";
  } else if (matchProjectAddFeatureRoute) {
    return "project-add-feature";
  } else if (matchAddProjectRoute) {
    return "add-project";
  } else if (matchAboutProductsRoute) {
    return "about-products";
  } else if (matchCompanyRoute) {
    return "workspace";
  } else if (matchProjectRoute) {
    return "project";
  } else if (matchMemberRoute) {
    return "member";
  } else {
    return "unknown";
  }
}
